import React, { useContext } from 'react';
import { Card, createStyles, Group, MultiSelect, Select } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../context/AuthProvider';
import { ResourceContext } from '../../context/ContextWrapper';
import UserService from '../../services/UserService';
import { showAppNotifcation } from '../../utility/NotificationConfigs';

const useStyles = createStyles(() => ({
  indicators: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

function StatsControls() {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const { getOptions, setOptions } = useContext(AuthContext);
  const options = getOptions();

  const resourceCtx = useContext(ResourceContext);

  const updateOptions = (option) => {
    const opt = {
      ...options,
      ...option,
    };
    UserService.saveOptions({ options: opt })
      .then(() => {
        setOptions(opt);
      })
      .catch(() => showAppNotifcation(false, t('main.OptionCannotChange')));
  };

  return (
    <Card
      withBorder
      p="xl"
      radius="md"
      sx={{ height: '100%', overflow: 'unset' }}
    >
      <Group className={classes.indicators}>
        <MultiSelect
          label={t('UserSettings.SelectKeyFigures')}
          placeholder={t('UserSettings.SelectKeyFigures')}
          data={resourceCtx.entities.map((e) => ({
            value: e.id.toString(),
            label: e.name,
          }))}
          value={options.indicator_resource}
          onChange={(value) => {
            updateOptions({
              indicator_resource: value,
            });
          }}
        />
        <Select
          label={t('UserSettings.SelectTimePeriod')}
          placeholder={t('UserSettings.SelectTimeSpan')}
          dropdownPosition="bottom"
          data={[
            { value: '0', label: t('UserSettings.total') },
            { value: '1', label: t('UserSettings.LastHour') },
            { value: '2', label: t('UserSettings.Last2Hours') },
            { value: '3', label: t('UserSettings.Last3Hours') },
            { value: '6', label: t('UserSettings.Last6Hours') },
            { value: '12', label: t('UserSettings.Last12Hours') },
            { value: '24', label: t('UserSettings.Last24Hours') },
          ]}
          value={options.indicator_timespan.toString()}
          onChange={(e) => {
            const timespan = parseInt(e);
            updateOptions({
              indicator_timespan: timespan,
            });
          }}
        />
      </Group>
    </Card>
  );
}

export default StatsControls;
